import React from 'react'
import icon from "../../components/Utilities/Icons"

export const ErrorBoundaryLayout = ({ error, resetErrorBoundary }) => {
    return (
        <div
            className="ud_pg_not_found"
        >
            <div className="ud_pg_not_found_img">
                <icon.NotFoundIcon />
            </div>
            <div className="ud_pg_not_found_title"
            >
                Something went wrong.
            </div>
            <p className="ud_pg_not_found_desc"
            >{error.message}</p>
            <button
                className="ud_pg_not_found_btn"
                onClick={resetErrorBoundary}
            >
                Go to Styldod home
            </button>
        </div>
    )
}
